import TabLink from './TabLink';

export default TabLink;
